import { Region } from '../../i18n';
const NUM_INTERVAL_MAP = {
    w: [Region.jp],
    k: [Region.id, Region.my, Region.ph, Region.sg, Region.th, Region.vn, Region.gb, Region.us],
};
export function formatNum(num, _config = {}) {
    let val = `${num}`;
    const config = {
        decimal: 1,
        units: ['万', '億'],
        needDiv: true,
        ..._config,
    };
    const { decimal } = config;
    if (config.type === 'KMB') {
        if (num >= 1e10) {
            val = `${(num / 1e9).toFixed(0)}B`;
        }
        else if (num >= 1e9) {
            val = `${(num / 1e9).toFixed(decimal).replace(/\.0*$/, '')}B`;
        }
        else if (num >= 1e7) {
            val = `${(num / 1e6).toFixed(0)}M`;
        }
        else if (num >= 1e6) {
            val = `${(num / 1e6).toFixed(decimal).replace(/\.0*$/, '')}M`;
        }
        else if (num >= 1e4) {
            val = `${(num / 1e3).toFixed(0)}K`;
        }
        else if (num >= 1e3) {
            val = `${(num / 1e3).toFixed(decimal).replace(/\.0*$/, '')}K`;
        }
        else {
            val = `${num}`;
        }
    }
    else if (config.type === 'KM') {
        if (num >= 10e6) {
            const unitDigit = (num / 1e6).toString().split('.')[0];
            const oneDecimal = ((num - Number(unitDigit) * 1e6) / 1e5).toString().split('.')[0];
            if (Number(oneDecimal) >= 1) {
                val = `${String(unitDigit)}.${String(oneDecimal)}${config.units[0]}`;
            }
            else {
                val = `${String(unitDigit)}${config.units[1]}`;
            }
        }
        else if (num >= 1e4) {
            const unitDigit = (num / 1e3).toString().split('.')[0];
            const oneDecimal = ((num - Number(unitDigit) * 1e3) / 1e2).toString().split('.')[0];
            if (Number(oneDecimal) >= 1) {
                val = `${String(unitDigit)}.${String(oneDecimal)}${config.units[0]}`;
            }
            else {
                val = `${String(unitDigit)}${config.units[0]}`;
            }
        }
        else {
            val = `${num}`;
        }
    }
    else if (config.type === 'WY') {
        if (num >= 1e10) {
            val = ~~(num / 1e8) + config.units[1];
        }
        else if (num >= 1e8) {
            val = (num / 1e8).toFixed(decimal).replace(/\.0*$/, '') + config.units[1];
        }
        else if (num >= 1e6) {
            val = ~~(num / 1e4) + config.units[0];
        }
        else if (num >= 1e4) {
            val = (num / 1e4).toFixed(decimal).replace(/\.0*$/, '') + config.units[0];
        }
        else {
            val = `${num}`;
        }
    }
    else if (config.type === 'W') {
        if (num >= 1e4) {
            const unitDigit = (num / 1e4).toString().split('.')[0];
            const oneDecimal = ((num - Number(unitDigit) * 1e4) / 1e3).toString().split('.')[0];
            if (Number(oneDecimal) >= 1) {
                val = `${String(unitDigit)}.${String(oneDecimal)}${config.units[0]}`;
            }
            else {
                val = `${String(unitDigit)}${config.units[0]}`;
            }
        }
        else {
            val = `${num}`;
        }
    }
    else if (config.upperLimit && num >= config.upperLimit) {
        val = config.upperText;
    }
    if (config.needDiv) {
        val = val.replace(/\d+/, function (s) {
            return s.replace(/(\d)(?=(\d{3})+$)/g, '$1,');
        });
    }
    if (config.tmpl) {
        return config.tmpl.replace('%s', val);
    }
    return val;
}
export function formatNumByRegion(num, region, t) {
    if (NUM_INTERVAL_MAP.w.includes(region)) {
        const type = 'W';
        const units = [t('common_ten_thousand')];
        return formatNum(num, { type, units, needDiv: false });
    }
    if (NUM_INTERVAL_MAP.k.includes(region)) {
        const type = 'KM';
        const units = [t('common_thousand'), t('common_million')];
        return formatNum(num, { type, units, needDiv: false });
    }
    return '';
}
